<div class="user-menu-panel-container">
  <!-- Top Section (Blue) -->
  <div class="top-section">
    <!-- Close button -->
    <div class="close-button-container">
      <button class="close-button" (click)="onCloseClick()" aria-label="Close menu">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <!-- Menu items -->
    <div class="menu-items" role="menu">
      @for (item of menuItems(); track item.label; let i = $index) {
        <div
          class="menu-item"
          role="menuitem"
          tabindex="0"
          [attr.aria-expanded]="item.expandable ? isExpanded(i) : null"
          [attr.aria-haspopup]="item.expandable ? 'true' : null"
          (click)="onMenuItemClick(item, i)"
          (keydown)="onMenuItemKeydown($event, item, i)"
        >
          <div class="menu-item-content flex-row flex-justify-space-between flex-align-center">
            <div class="menu-item-label">{{ item.label | translate }}</div>
            @if (item.expandable) {
              <fa-icon
                [icon]="isExpanded(i) ? faChevronUp : faChevronDown"
                class="menu-item-icon"
                aria-hidden="true"
              ></fa-icon>
            }
          </div>
          <div class="menu-item-divider"></div>
        </div>

        <!-- Children (submenu) -->
        @if (item.expandable && isExpanded(i) && item.children) {
          <div class="submenu" role="menu">
            @for (child of item.children; track child.label) {
              <div
                class="submenu-item"
                role="menuitem"
                tabindex="0"
                (click)="onChildItemClick(child, $event)"
                (keydown)="onChildItemKeydown($event, child)"
              >
                <div class="submenu-item-content">
                  <div class="submenu-item-label">{{ child.label | translate }}</div>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>

  <!-- Bottom Section (White/Gray) -->
  <div class="bottom-section">
    <!-- User avatar -->
    <div class="user-avatar-container">
      <div class="user-avatar">
        @if (getUserInitials()) {
          <div class="avatar-initials">{{ getUserInitials() }}</div>
        } @else {
          <div class="avatar-initials">?</div>
        }
      </div>
    </div>

    <!-- User info -->
    <div class="user-info">
      @if (getUserFullName()) {
        <div class="user-name">{{ getUserFullName() }}</div>
      }
      @if (getUserEmail()) {
        <div class="user-email">{{ getUserEmail() }}</div>
      }
    </div>

    <!-- Logout button - only show when logged in -->
    @if (isLoggedIn()) {
      <button
        class="logout-button"
        [attr.aria-label]="'dottnet.usermenu.logout' | translate"
        (click)="onLogoutClick()"
      >
        {{ 'dottnet.usermenu.logout' | translate }}
      </button>
    }
  </div>
</div>
